import { components } from '../../../utils/components';

const ReportTable = ({ showTable, setShowTable }) => {
  const Component = components[showTable?.tableName] && components[showTable?.tableName].component;

  return (
    Component && (
      <Component
        tableData={showTable?.tableData}
        date={showTable?.date}
        totalResults={showTable?.totalResults}
        fromDate={showTable?.fromDate}
        toDate={showTable?.toDate}
        dynamicHeaders={showTable?.dynamicHeaders}
        tableName={showTable?.tableName}
        setShowTable={setShowTable}
        showTable={showTable}
      />
    )
  );
};

export default ReportTable;
